<template>
  <q-card square class="sticky-header-card">
    <div class="center-sticky-header">
      <div class="sticky-margin" style="flex-flow:row-reverse nowrap">
        <div class="sticky-location">
          <q-select
            style="margin-right:5px"
            label-color="grey-7"
            color="grey-7"
            dense
            label="Status Filter"
            outlined
            :options="options"
            :option-value="(opt) => opt.value"
            :option-label="(opt) => opt.name"
            v-model="status"
          >
            <template v-slot:append>
              <i
                style="font-size:15px;cursor:pointer;"
                class="fas fa-times clearable"
                v-if="status"
                @click="status = ''"
              /> </template
          ></q-select>
        </div>
      </div>
    </div>
  </q-card>
</template>
<script>
import axios from "@/axios";
export default {
  data() {
    return {
      options: [
        { name: "Working", value: "working" },
        { name: "Finished", value: "finished" },
        { name: "Failed", value: "failed" },
      ],
      selected: [],
    };
  },
  mounted() {
    this.$store.state.history.vehicles.length === 0 && this.getAllVehicles();
  },
  computed: {
    loading: {
      get() {
        return this.$store.state.history.loading;
      },
      set(val) {
        this.$store.commit("history/SET_LOADING", val);
      },
    },
    per() {
      return this.$store.state.history.per;
    },
    vehicles: {
      get() {
        return this.$store.state.history.vehicles;
      },
      set(val) {
        this.$store.commit("history/SET_VEHICLES", val);
      },
    },
    status: {
      get() {
        return this.$store.state.history.status;
      },
      set(val) {
        this.$store.commit("history/SET_STATUS", val);
      },
    },
  },
  methods: {
    async getAllVehicles() {
      try {
        const {
          data: { items },
        } = await axios.get("vehicles", { params: { per: this.per } });
        this.vehicles = items.map((vehicle) => {
          const { id, vin } = vehicle;
          return { id, vin };
        });
      } catch (error) {}
    },
    async generate() {
      try {
        this.$store.commit("history/SET_LOADING", true);
        const {
          data: { data, message },
        } = await axios.put("reports/history-reports", {
          vehicles: this.selected.map((veh) => veh.id),
        });
        this.$q.notify({
          message,
          timeout: 250,
          position: "top-right",
          progress: true,
          type: "positive",
        });
        this.$store.commit("history/ADD_REPORT", data);
      } catch (error) {
        this.$q.notify({
          message: "Something wrong.",
          timeout: 250,
          position: "top-right",
          progress: true,
          type: "negative",
        });
      } finally {
        this.$refs.menu.hide();
        this.$store.commit("history/SET_LOADING", false);
      }
    },
  },
};
</script>
